// extracted by mini-css-extract-plugin
export default {"block":"block___Hxe7O","btn":"btn___TKlXB"};